import axios from 'axios';
import { wrapClientForUploadFile } from '../request';
import { FileApi } from './components/FileApi';

class FileService {
  FILE_SERVICE_HOST = window.REACT_APP_FILE_SERVICE_API_URL;

  private fileServiceClient = wrapClientForUploadFile(
    axios.create({
      baseURL: window.REACT_APP_FILE_SERVICE_API_URL,
    })
  );

  fileApis = new FileApi(this.fileServiceClient);
}

export default new FileService();
